<template>
    <div class="flex flex-col gap-8">
        <EventCalendarControls
            v-model:is-preview="isPreview"
            class="w-full md:w-[400px] max-w-full ms-auto"
        />
        <Suspense :key="`${isPreview}`">
            <template #default>
                <component :is="calendarTypeComponent" />
            </template>
            <template #fallback>
                <EventCalendarLoader data-test="event-calendar-fallback" />
            </template>
        </Suspense>
    </div>
</template>

<script setup lang="ts">
    import { useUrlParams } from '~/composables/urlParams';
    import { ref, computed, type PropType } from 'vue';
    import EventCalendarControls from '~/components/eventCalendar/EventCalendarControls.vue';
    import EventCalendarList from '~/components/eventCalendar/EventCalendarList.vue';
    import EventCalendarPreview from '~/components/eventCalendar/EventCalendarPreview.vue';
    import EventCalendarLoader from '~/components/eventCalendar/EventCalendarLoader.vue';
    import { storeToRefs } from 'pinia';
    import { useNavigationStore } from '~/stores/navigationStore';
    import { useEventCalendarStore } from '~/stores/eventCalendar';

    const navigationStore = useNavigationStore();
    // Loader logic kept/removed based on whether async data fetching is present
    const { getLastActiveNavItem } = storeToRefs(navigationStore);

    const eventCalendarStore = useEventCalendarStore();
    const { setPostGroupIds } = eventCalendarStore;

    const { getParam } = useUrlParams();
    const isPreview = ref(getParam('preview') === 'true');

    const props = defineProps({
        postGroupIds: {
            type: Array as PropType<number[] | null>,
            required: false,
            default: () => undefined,
        },
    });

    setPostGroupIds(props.postGroupIds ?? getLastActiveNavItem?.value?.postGroupIds ?? []);

    const calendarTypeComponent = computed(() => isPreview.value ? EventCalendarPreview : EventCalendarList);
</script>
